import { deepFreeze } from '../utils/deepFreeze';
import { DeepReadonly, IMappingType } from 'types';

export const defaultMappingTypes: DeepReadonly<IMappingType> = deepFreeze({
  MAP_DEFAULT_FALSE: {
    default: false
  },
  MAP_DEFAULT_TRUE: {
    default: true
  },
  MAP_OFFER_ID_UNKNOWN: {
    default: '1'
  }
});
